import { render, staticRenderFns } from "./UserBookAppointmentModalView.vue?vue&type=template&id=2f1f8b92&scoped=true&"
import script from "./UserBookAppointmentModalView.vue?vue&type=script&lang=ts&"
export * from "./UserBookAppointmentModalView.vue?vue&type=script&lang=ts&"
import style0 from "./UserBookAppointmentModalView.vue?vue&type=style&index=0&id=2f1f8b92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f8b92",
  null
  
)

export default component.exports